import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import CloseButton from './CloseButton';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  debounce?: number;
  /** Accessible name; defaults to the placeholder. */
  ariaLabel?: string;
}

export default function SearchInput({
  value,
  onChange,
  placeholder = 'Search...',
  className = '',
  ariaLabel,
}: SearchInputProps) {
  return (
    <div className={`relative ${className}`}>
      <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
        <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
      </div>
      <input
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-label={ariaLabel || placeholder}
        className="block w-full rounded-md border border-gray-300 bg-white py-2 pl-10 pr-9 text-sm placeholder-gray-500 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 [&::-webkit-search-cancel-button]:hidden"
        placeholder={placeholder}
      />
      {value && (
        <CloseButton onClick={() => onChange('')} label="Clear search" className="absolute inset-y-0 right-0" />
      )}
    </div>
  );
}
